import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { Cancel } from "@material-ui/icons";

import LoadGender from "components/services/LoadGender";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function EditStudent(props) {
  const classes = useStyles();

  const data = props.id;
  const [returnLogin, setReturnLogin] = React.useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    id: data.id,
    fecha_emision: data.fecha_emision,
    nombres: data.nombres,
    //apellidos: data.apellidos,
    identificacion: data.identificacion,
    tipo_estudios: data.tipo_estudios,
    programa_academico: data.programa_academico,
    email_personal: data.correo_personal,
    gender_id: data.gender_id,
    gendername: data.gendername,
    genderdata: { id: data.gender_id, name: data.gendername },
    email_institucional: data.correo_institucional,
    celular: data.celular,
    telefono: data.telefono,
    fecha_nacimiento: data.fecha_nacimiento,
    inicio_clases: data.inicio_clases,
    errorGender: false,
    errorNombres: false,
    //errorApellidos: false,
    errorEmailPersonal: false,
    errorIdentificacion: false,
    errorFechaEmision: false,
    errorFechaNacimiento: false,
    errorCelular: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorNombres: false,
      // errorApellidos: false,
      errorEmailPersonal: false,
      errorCelular: false,
    });
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);

    if (values.nombres.length === 0) {
      setValues({ ...values, errorNombres: true });
      setMensaje('El campo "Nombres" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } /* else if (values.apellidos.length === 0) {
      setValues({ ...values, errorApellidos: true });
      setMensaje('El campo "Apellidos" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    }*/ else if (values.identificacion.length === 0) {
      setValues({ ...values, errorIdentificacion: true });
      setMensaje('El campo "Identificación" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.fecha_emision === "") {
      setValues({ ...values, errorFechaEmision: true });
      setMensaje('El campo "Fecha de emisión" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.gendername.length === 0) {
      setValues({ ...values, errorGender: true });
      setMensaje('El campo "Género" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.fecha_nacimiento === "") {
      setValues({ ...values, errorFechaNacimiento: true });
      setMensaje('El campo "Fecha de nacimiento" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.email_personal.length === 0) {
      setValues({ ...values, errorEmailPersonal: true });
      setMensaje('El campo "Correo personal" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.celular.length === 0) {
      setValues({ ...values, errorCelular: true });
      setMensaje('El campo "Un celular" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else {
      const dataValue2 = {
        id: values.id,
        fecha_emision: values.fecha_emision,
        identificacion: values.identificacion,
        nombres: values.nombres,
        // apellidos: values.apellidos,
        tipo_estudios: values.tipo_estudios,
        programa_academico: values.programa_academico,
        gender_id: values.gender_id,
        email_personal: values.email_personal,
        email_institucional: values.email_institucional,
        celular: values.celular,
        telefono: values.telefono,
        fecha_nacimiento: values.fecha_nacimiento,
        inicio_clases: values.inicio_clases,
        keyAplication: keyAplication,
      };

      axios
        .post(`${urlServices}routes_studentupdate.php`, dataValue2, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            setMensaje("Modificado con exito.");
            setOpenAlert(true);
            setError("success");
            props.callBackRefresh();
          } else if (response.data.code === 0) {
            setMensaje("Error al modificar.");
            setOpenAlert(true);
            setError("error");
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 200);
          } else {
            setErrorServer(true);
          }
        });
    }
  };

  const handleDateNacimientoChange = (e) => {
    setValues({
      ...values,
      fecha_nacimiento: e.target.value,
      errorFechaNacimiento: false,
    });
  };

  const handleDateEmisionChange = (e) => {
    setValues({
      ...values,
      fecha_emision: e.target.value,
      errorFechaEmision: false,
    });
  };

  const handleDateInicioClasesChange = (e) => {
    setValues({
      ...values,
      inicio_clases: e.target.value,
    });
  };

  const handleIndentificacionChange = (e) => {
    setValues({
      ...values,
      identificacion: e.target.value,
      errorIdentificacion: false,
    });
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {errorServer ? (
                  <Alert severity="error">
                    Error al registrar en el servidor
                  </Alert>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>
                      Editar estudiante
                    </div>
                    <div className={classes.lineBottom}></div>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      autoComplete="off"
                      name="nombres"
                      value={values.nombres}
                      onChange={handleChange("nombres")}
                      label="Nombres"
                      error={values.errorNombres}
                      fullWidth
                      required
                    />
                  </Grid>
                  {/*<Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="apellidos"
                      value={values.apellidos}
                      onChange={handleChange("apellidos")}
                      label="Apellidos"
                      error={values.errorApellidos}
                      fullWidth
                      required
                    />
                  </Grid>*/}
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="date"
                      label="Fecha de emisión"
                      type="date"
                      value={values.fecha_emision}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => handleDateEmisionChange(e)}
                      autoComplete="off"
                      error={values.errorFechaEmision}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="identificacion"
                      value={values.identificacion}
                      onChange={handleIndentificacionChange}
                      label="Identificación"
                      error={values.errorIdentificacion}
                      fullWidth
                      required
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LoadGender
                      refresh={changeGender}
                      value={values.genderdata}
                      error={values.errorGender}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="celular"
                      value={values.celular}
                      onChange={handleChange("celular")}
                      label="celular"
                      fullWidth
                      type="number"
                      error={values.errorCelular}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="telefono"
                      value={values.telefono}
                      onChange={handleChange("telefono")}
                      label="Teléfono"
                      fullWidth
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="date"
                      label="Fecha nacimiento"
                      type="date"
                      value={values.fecha_nacimiento}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => handleDateNacimientoChange(e)}
                      autoComplete="off"
                      error={values.errorFechaNacimiento}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      autoComplete="off"
                      name="tipo_estudios"
                      value={values.tipo_estudios}
                      onChange={handleChange("tipo_estudios")}
                      label="Tipo estudios"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email_personal"
                      value={values.email_personal}
                      onChange={handleChange("email_personal")}
                      label="Correo personal"
                      error={values.errorEmailPersonal}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email_institucional"
                      value={values.email_institucional}
                      onChange={handleChange("email_institucional")}
                      label="Correo institucional"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      name="date"
                      label="Inicio de clases"
                      type="date"
                      value={values.inicio_clases}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => handleDateInicioClasesChange(e)}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="programa_academico"
                      value={values.programa_academico}
                      onChange={handleChange("programa_academico")}
                      label="Programa académico"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit}
                        onClick={submitForm}
                      >
                        Guardar
                      </Button>
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
